import { render } from "./FormularioPersona.vue?vue&type=template&id=88838116&scoped=true"
import script from "./FormularioPersona.vue?vue&type=script&lang=js"
export * from "./FormularioPersona.vue?vue&type=script&lang=js"

import "./FormularioPersona.vue?vue&type=style&index=0&id=88838116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88838116"]])

export default __exports__